import React, { forwardRef, useState, useEffect } from "react";
import cx from "classnames";
import * as Select from "@radix-ui/react-select";
import {
  CheckIcon,
  ChevronUpIcon,
  ChevronDownIcon
} from "@radix-ui/react-icons";
import styles from "./styles.module.scss";

export default function SelectBox({
  options,
  placeholder,
  ariaLabel,
  groupLabel = "",
  onChange,
  selection,
  wrapperClassName,
  selectClassName,
  dataAttribute
}) {
  const [value, setValue] = useState(selection || "");

  useEffect(() => {
    setValue(selection || "");
  }, [selection]);

  const SelectItem = forwardRef(
    ({ children, className, ...props }, forwardedRef) => {
      return (
        <Select.Item className={styles.item} {...props} ref={forwardedRef}>
          <Select.ItemText>{children}</Select.ItemText>
          <Select.ItemIndicator className={styles.checkIcon}>
            <CheckIcon />
          </Select.ItemIndicator>
        </Select.Item>
      );
    }
  );
  SelectItem.displayName = "SelectItem";

  const renderSelectBox = () => {
    return options.map((option, i) => (
      <span key={i}>
        <SelectItem value={option?.value ?? option}>
          {option?.label ?? option}
        </SelectItem>
        {i + 1 !== options.length && (
          <Select.Separator className={styles.separator} />
        )}
      </span>
    ));
  };

  useEffect(() => {
    onChange(value);
  }, [value]);

  return (
    <div className={cx(styles.container, wrapperClassName)}>
      <Select.Root value={value} onValueChange={setValue}>
        <Select.Trigger
          className={cx(styles.trigger, selectClassName)}
          aria-label={ariaLabel}
          data-testid={dataAttribute}
        >
          <Select.Value placeholder={placeholder} />
          <Select.Icon className={styles.chevronDownIcon}>
            <ChevronDownIcon />
          </Select.Icon>
        </Select.Trigger>
        <Select.Portal>
          <Select.Content className={styles.content}>
            <Select.ScrollUpButton className={styles.scrollButton}>
              <ChevronUpIcon />
            </Select.ScrollUpButton>
            <Select.Viewport>
              <Select.Group>
                <Select.Label className={styles.groupLabel}>
                  {groupLabel}
                </Select.Label>
                <Select.Separator className={styles.separator} />
              </Select.Group>
              {renderSelectBox()}
            </Select.Viewport>
            <Select.ScrollDownButton className={styles.scrollButton}>
              <ChevronDownIcon />
            </Select.ScrollDownButton>
          </Select.Content>
        </Select.Portal>
      </Select.Root>
    </div>
  );
}
